/**
 * Kind of integrations
 *
 * @description
 * List of available integrations
 *
 * Warning !! For other kinds, key maxlength is 20 characters
 */
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["AbTest"] = "abtests";
    IntegrationType["Collaboration"] = "collaboration";
    IntegrationType["Enrichment"] = "enrichment";
    IntegrationType["Segment"] = "segments";
})(IntegrationType || (IntegrationType = {}));
export var UserTypeAccess;
(function (UserTypeAccess) {
    UserTypeAccess["CustomerOnly"] = "customerOnly";
    UserTypeAccess["Everyone"] = "everyone";
})(UserTypeAccess || (UserTypeAccess = {}));
export const IntegrationProvider = {
    AdobeV2: 'adobe2.0',
    Dexem: 'dexem',
    Freespee: 'freespee',
    Google360: 'google360',
    Jira: 'jira',
    Slack: 'slack',
    Kameleoon: 'kameleoon',
    KameleoonV2: 'kameleoon2.0',
    Monetate: 'monetate',
    Microsoft: 'microsoft',
    Fake: 'fake',
    Unknown: 'unknown',
};
export const { Jira, Slack, Kameleoon, KameleoonV2, Fake, Monetate, AdobeV2, Google360, Freespee, Dexem, Unknown } = IntegrationProvider;
export const AbTestProvider = { Kameleoon, KameleoonV2, Monetate, Fake };
export const SegmentProvider = { Google360, AdobeV2 };
export const EnrichmentProvider = { Freespee, Dexem };
/**
 * Status of external integrations
 *
 * @description
 * List of external integrations statuses
 *
 * Warning !! For other statuses, key maxlength is 20 characters
 */
export var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["Pending"] = "pending";
    IntegrationStatus["Error"] = "error";
    IntegrationStatus["Incomplete"] = "incomplete";
    IntegrationStatus["Success"] = "success";
    IntegrationStatus["Partial"] = "partial";
})(IntegrationStatus || (IntegrationStatus = {}));
/**
 * Steps of external integrations
 *
 * @description
 * List of external integrations steps
 *
 * Warning !! For other steps, key maxlength is 20 characters
 */
export var IntegrationSteps;
(function (IntegrationSteps) {
    IntegrationSteps["Definition"] = "definition";
    IntegrationSteps["Configuration"] = "configuration";
    IntegrationSteps["Selection"] = "selection";
    IntegrationSteps["Ready"] = "";
})(IntegrationSteps || (IntegrationSteps = {}));
const MAX_SEGMENT_INTEGRATIONS = Number.MAX_SAFE_INTEGER;
const MAX_ABTEST_INTEGRATIONS = 1;
const MAX_COLLABORATION_INTEGRATIONS = 1;
const MAX_ENRICHMENT_INTEGRATIONS = 1;
export const MAX_INTEGRATION_PER_PROVIDER = {
    [IntegrationProvider.AdobeV2]: MAX_SEGMENT_INTEGRATIONS,
    [IntegrationProvider.Dexem]: MAX_ENRICHMENT_INTEGRATIONS,
    [IntegrationProvider.Freespee]: MAX_ENRICHMENT_INTEGRATIONS,
    [IntegrationProvider.Google360]: MAX_SEGMENT_INTEGRATIONS,
    [IntegrationProvider.Jira]: MAX_COLLABORATION_INTEGRATIONS,
    [IntegrationProvider.Slack]: MAX_COLLABORATION_INTEGRATIONS,
    [IntegrationProvider.Kameleoon]: MAX_ABTEST_INTEGRATIONS,
    [IntegrationProvider.KameleoonV2]: MAX_ABTEST_INTEGRATIONS,
    [IntegrationProvider.Monetate]: MAX_ABTEST_INTEGRATIONS,
    [IntegrationProvider.Microsoft]: MAX_COLLABORATION_INTEGRATIONS,
    // Fake integration for tests
    [IntegrationProvider.Fake]: 0,
};
export const MAX_INTEGRATION_PER_TYPE = {
    [IntegrationType.AbTest]: 1,
    [IntegrationType.Collaboration]: Number.MAX_SAFE_INTEGER,
    [IntegrationType.Enrichment]: Number.MAX_SAFE_INTEGER,
    [IntegrationType.Segment]: Number.MAX_SAFE_INTEGER,
};
export const MAX_INTEGRATION_SEGMENTS = 200;
export var ExternalSegmentStatus;
(function (ExternalSegmentStatus) {
    ExternalSegmentStatus["ACTIVATED"] = "activated";
    ExternalSegmentStatus["REACTIVATED"] = "reactivated";
    ExternalSegmentStatus["DEACTIVATED"] = "deactivated";
})(ExternalSegmentStatus || (ExternalSegmentStatus = {}));
export var ReleaseStatus;
(function (ReleaseStatus) {
    ReleaseStatus["BETA"] = "beta";
    ReleaseStatus["PRODUCTION"] = "production";
})(ReleaseStatus || (ReleaseStatus = {}));
//# sourceMappingURL=integrations.js.map